import { SimpleDictionary } from './dictionary'
import { Owner } from './user'
import { Word } from './word'

export class Pair {
  id: number
  owner: Owner
  word_1: Word
  word_2: Word
  created_at: string
  last_update: string
  likes: number
  is_liked: boolean
  bookmarks: number
  is_bookmarked: boolean
  dictionaries: SimpleDictionary[]
  time_since_creation: string
  is_mine?: boolean
}
